import React, { FC } from 'react';
import { MenuList as BaseMenuList } from '@prime/core';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

import { MenuListData } from '../model/menuModel';
import LinkMenuItem from '../LinkMenuItem';

interface MenuListProps {
  title: string;
  nodeId: string;
  icon: IconDefinition;
  menuItems: MenuListData[];
}

const MenuList: FC<MenuListProps> = (props) => {
  const { t } = useTranslation();

  return (
    <BaseMenuList icon={<FontAwesomeIcon icon={props.icon} />} title={t(props.title)} nodeId={props.nodeId}>
      {props.menuItems.map(({ label, to }) => (
        <LinkMenuItem label={label} to={to} key={to} />
      ))}
    </BaseMenuList>
  );
};

export default MenuList;
